import { Component, OnInit, Input } from '@angular/core';
import { Information } from '@model';

@Component({
    selector: 'app-epi-content-display',
    templateUrl: './epi-content-display.component.html',
    standalone: false
})
export class EpiContentDisplayComponent implements OnInit {
  @Input()
  information: Information;

  constructor() {}

  ngOnInit() {}
}
